export const pageDetailsReducer = (state = { content: [], loading: true, dataLoaded: false }, action) => {
    switch (action.type) {
      case 'PAGE_DETAILS_REQUEST':
        return { ...state, loading: true };
      case 'PAGE_DETAILS_SUCCESS':
        return { 
          ...state, 
          loading: false, 
          content: action.payload,
          dataLoaded: true
        };
      case 'PAGE_DETAILS_FAIL':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  